module.exports = __webpack_public_path__ + "img/img_platform04.d112fb0c.jpg";